import { useHandlers } from '../../../context/page-context';
import type { BillingApiContract } from '../api';

export function useBillingApi(): { billingApi: BillingApiContract } {
  const { apis } = useHandlers();
  return { billingApi: apis.billing };
}
